import * as React from 'react';

export interface IBlinkerProps {
    value: number;
    customClass?: string;
    placeHolder?: string;
}

export class Blinker extends React.Component<IBlinkerProps> {
    private change = '';
    private repeatChange = true;
    private defaultPlaceholder = '-';

    componentWillReceiveProps(nextProps: IBlinkerProps) {
        this.change = '';
        if (nextProps.value) {
            if (nextProps.value !== this.props.value) {
                this.change += this.repeatChange ? ' blink-me2 ' : ' blink-me2R ';
                this.repeatChange = !this.repeatChange;
            }
        }
    }

    render() {
        return (
            <span className={`blinker ${this.props.customClass} ${this.change}`}>
                {isNaN(this.props.value) ? (this.props.placeHolder ? this.props.placeHolder : this.defaultPlaceholder) : this.props.value}
            </span>
        );
    }
};
